/**
 * Chart documentation shown behind the info icon on the Custom Funnels dashboard.
 *
 * Keys match the chart link property names in `MopaCustomFunnelsComponent`.
 */
export const MopaCustomFunnelsChartDocs = {
    funnels_users_by_step_cnt: /* HTML */ `<p>
            Share of the funnel's first-step players still present at each step.
        </p>
        <pre>
  players at the step (numerator)
  ------------------------------
  players at the first step (denominator)
    </pre
        >
        <p>
            <strong>Axes:</strong> X - funnel steps in <code>step_id</code>
            order; Y - share of first-step players, in %.
        </p>
        <p>
            Players are distinct <code>player_id</code>, so repeating a step
            counts once. In <em>closed</em> mode only players who passed every
            earlier step count; in <em>open</em> mode a player can show up at a
            step without the ones before it.
        </p>
        <p>
            The tooltip adds % of previous step, the user count and
            Q1-Q2(median)-Q3 statistics for energy spent and time.
        </p>
        <p>Source: <code>bi_viz.dashboard_funnels</code>.</p>
        <h2>Funnel step name legend</h2>
        <p><i>(abbreviation - event name)</i></p>

        <p>DO - DialogOpened</p>
        <p>CS - CutsceneStart</p>
        <p>SV - ScreenView</p>
        <p>ZO - ZoomOpened</p>
        <p>IC - ItemCollected</p>
        <p>MG - MiniGameStart</p>
        <p>HO_start - HiddenObjectStart</p>
        <p>DAC - DecorationAmountChanged</p>
        <p>MFT - MetaFTUEFlowTaskStarted</p>
        <p>MFFC - MetaFTUEFlowClosed</p>
        <p>MRC - MetaRewardClaimed</p>`,

    funnels_balance_info: /* HTML */ `<p>
            Helper chart - every bar is a constant 1 and the y-axis is hidden,
            so the bar heights carry no meaning.
        </p>
        <p>
            <strong>Axes:</strong> X - funnel steps in <code>step_id</code>
            order; Y - nothing readable, see the tooltip.
        </p>
        <p>
            It exists for its tooltip: per step, energy and hints spent since
            the first step and the current energy, gems and hints balances, each
            as Q1-Q2(median)-Q3 across the players at that step.
        </p>
        <p>Source: <code>bi_viz.dashboard_funnels</code>.</p>`,

    funnels_percentage_change_from_previous_step: /* HTML */ `<p>
            Share of players lost between two consecutive funnel steps.
        </p>
        <pre>
  players at the step (numerator)
  ------------------------------
  players at the previous step (denominator)
    </pre
        >
        <p>
            <strong>Axes:</strong> X - funnel steps in <code>step_id</code>
            order; Y - share of players lost at the step, in %.
        </p>
        <p>Plotted as 1 minus that ratio; the first step has no value.</p>
        <p>Source: <code>bi_viz.dashboard_funnels</code>.</p>`,

    funnels_steps_with_median: /* HTML */ `<p>
            Funnel retention plotted against how long players take to reach each
            step.
        </p>
        <p>
            <strong>Axes:</strong> X - median (Q2) minutes between the player's
            first step and that step; Y - share of first-step players still at
            the step, in %.
        </p>
        <p>
            Steps bunch up where players move fast and spread out where they
            stall.
        </p>
        <p>Source: <code>bi_viz.dashboard_funnels</code>.</p>`,
} as const;
